import { Component, Input, isDevMode, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SelectOptions } from '@cbuild/controls';
import {
  CsValidators,
  enumToSelectOptions,
  FormStateControl,
  TaskTriggerCallTypes
} from '@cbuild/shared';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs';
import { CallCenterService } from '../../call-center.service';

@Component({
  selector: 'cs-create-task',
  standalone: false,
  templateUrl: './create-task.component.html',
  styleUrls: ['./create-task.component.scss']
})
export class CreateTaskComponent extends FormStateControl implements OnInit {
  @Input()
  public form: FormGroup;

  @Input()
  public pipelineId: number;

  public typeOptions: SelectOptions;
  public userOptions$: Observable<SelectOptions>;
  public triggerTypes: SelectOptions;
  public $onDestroy = new Subject();

  @Input()
  public hasMandatoryFollowUp: boolean;
  @Input()
  public teamUsersCount: number;

  constructor(private fb: FormBuilder, private service: CallCenterService) {
    super();
  }

  public ngOnInit(): void {
    if (isDevMode() && !this.form) {
      throw new Error('Invalid Lead or parent from');
    }
    this.userOptions$ = this.service.getTaskUsers(this.pipelineId);
    this.triggerTypes = enumToSelectOptions(TaskTriggerCallTypes, 'string');
    this.typeOptions = [
      { label: 'To-Do', value: 'To-Do' },
      { label: 'Call', value: 'Call' },
      { label: 'Email', value: 'Email' }
    ];
    this.updateInfoFrom();
  }

  private updateInfoFrom(): void {
    this.form
      .get('taskPipelineId')!
      .valueChanges.pipe(takeUntil(this.$onDestroy))
      .subscribe(result => {
        if (result) {
          this.userOptions$ = this.service.getTaskUsers(result);
        }
      });
    const group = this.form.get('task');
    if (!group) {
      this.infoForm = this.initializeInfoForm();
      this.form.addControl('task', this.infoForm);
    } else {
      this.infoForm = this.form.get('task') as FormGroup;
    }
  }

  private initializeInfoForm(): FormGroup {
    return this.fb.group({
      task: [''],
      type: [''],
      remindOn: [null, [CsValidators.startDateRangeValidator(this, 'dueDate')]],
      dueDate: [null, [CsValidators.endDateRangeValidator(this, 'remindOn')]],
      description: [''],
      assignedTo: [],
      triggerType: ['']
    });
  }
}
